import CitationDetailTabs from './CitationDetailTabs.container';
export default CitationDetailTabs;
